import { useState, useEffect } from 'react';
import constate from 'constate';
import Web3 from 'web3';
import Web3Modal from 'web3modal';
// @ts-ignore
import WalletConnectProvider from '@walletconnect/web3-provider';
import NonconformistUpsideDucks from "../abis/PortalDucks.json";
import NonconformistHellDucks from "../abis/NonconformistDucks.json";
import NonconformistOGDucks from "../abis/ScorchingDucks.json";
import CoinbaseWalletSDK from "@coinbase/wallet-sdk";

import {
  UPSIDE_CONTRACT_ADDRESS,
  HELL_CONTRACT_ADDRESS,
  OG_CONTRACT_ADDRESS
} from "../utils/constants";

const useCustomState = () => {
  const requiredNetworkId = 1;

  // Web3Modal
  const providerOptions = {
    walletlink: {
      package: CoinbaseWalletSDK, 
      options: {
        appName: "Web 3 Modal Demo",
        infuraId: "25437149b33e4a2185451746da28f9dd" 
      }
    },
    walletconnect: {
      package: WalletConnectProvider,
      options: {
        infuraId: "25437149b33e4a2185451746da28f9dd",
        network: 'mainnet',
      },
    },
  };
  const web3Modal = new Web3Modal({
    network: 'mainnet',
    cacheProvider: true,
    providerOptions,
  });

  // State
  const [web3, setWeb3] = useState<Web3 | null>(null);
  const [account, setAccount] = useState<string>('');

  const [network, setNetwork] = useState<number>(0);
  // @ts-ignore
  const [, setProvider] = useState<any>(null);
  const [upsideContract, setUpsideContract] = useState<any>(null);
  const [hellContract, setHellContract] = useState<any>(null);
  const [ogContract, setOgContract] = useState<any>(null);
  const [isConnected, setIsConnected] = useState<boolean>(false);

  // Effects
  useEffect(() => {
    if ( web3 ) {
      const upsideContractInstance = new web3.eth.Contract(
        // @ts-ignore
        NonconformistUpsideDucks.abi,
        UPSIDE_CONTRACT_ADDRESS
      );

      setUpsideContract(upsideContractInstance);

      const ogContractInstance = new web3.eth.Contract(
          // @ts-ignore
          NonconformistOGDucks.abi,
          OG_CONTRACT_ADDRESS
      );

      setOgContract(ogContractInstance);

      const hellContractInstance = new web3.eth.Contract(
          // @ts-ignore
          NonconformistHellDucks.abi,
          HELL_CONTRACT_ADDRESS
      );

      setHellContract(hellContractInstance);
    }
  }, [web3]); //eslint-disable-line

  useEffect(() => {
    const intervalNetwork = setInterval(function () {
      if (web3) {
        web3.eth.net.getId((err, currentNet) => {
          // No error and change in network
          if (!err && network > 0 && currentNet !== network) {
            if (currentNet === requiredNetworkId) {
              window.location.reload();
            } else if (network === requiredNetworkId) {
              //showNetworkErrorMessage();
            }
            setNetwork(currentNet);
          }
        });
      }
    }, 1000);

    return () => {
      clearInterval(intervalNetwork);
    };
  }, [network]); //eslint-disable-line

  const sendThroughPortal = async (ogId: string, hellId: string, secondId: string) => {
    return upsideContract.methods.sendThroughPortal(ogId, hellId, secondId).send({
      from: account,
      gas: 350000
    });
  }

  const isOgApproved = async () => {
    return ogContract.methods.isApprovedForAll(account, UPSIDE_CONTRACT_ADDRESS).call();
  }

  const isHellApproved = async () => {
    return hellContract.methods.isApprovedForAll(account, UPSIDE_CONTRACT_ADDRESS).call();
  }

  const setHellApproval = async () => {
    return hellContract.methods.setApprovalForAll(UPSIDE_CONTRACT_ADDRESS, true).send({
      from: account,
      gas: 60000
    });
  }

  const setOgApproval = async () => {
    return ogContract.methods.setApprovalForAll(UPSIDE_CONTRACT_ADDRESS, true).send({
      from: account,
      gas: 60000
    });
  }

  const connectWallet = async () => {
    try {
      const _provider = await web3Modal.connect();
      const _web3: Web3 = new Web3(_provider);
      setWeb3(_web3);
      setProvider(_provider);
      let _account = '';
      if (_provider && _provider.selectedAddress) {
        _account = _provider.selectedAddress;
        
      }
      if (!_account && _provider && _provider.accounts) {
        _account = _provider.accounts[0];
      }
      if (!account && _provider && _provider.address) {
        _account = _provider.address;
      }
      setAccount(_account);
      // TODO - review why _web3.eth.getAccounts() is not working
      let netId = await _web3.eth.net.getId();
      setNetwork(netId);
      //if (requiredNetworkId !== netId) showNetworkErrorMessage();
      setIsConnected(true);

    } catch (e) {
      console.log('Error > Connecting wallet');
      console.log(e);
    }
  };

  const disconnectWallet = () => {
    try {
      // @ts-ignore
      web3?.currentProvider.close();
    } catch (e) {}
    web3Modal.clearCachedProvider();
    setWeb3(null);
    setIsConnected(false);
    setAccount('');
  };

  const secondUsed = (id:any) => {
    return upsideContract.methods.used2GenIds(id).call()
  };

  return {
    web3,
    connectWallet,
    disconnectWallet,
    isConnected,
    account,
    sendThroughPortal,
    setHellApproval,
    isHellApproved,
    isOgApproved,
    setOgApproval,
    secondUsed
  };
};

const [StateProvider, useStateContext] = constate(useCustomState);

export { StateProvider, useStateContext };
